// extracted by mini-css-extract-plugin
export default {"settingRow":"Settings_settingRow__v-Kga"};